// Generated by ReScript, PLEASE EDIT WITH CARE


function initial_lat_lng(param) {
  return {
          lat: 0.0,
          lng: 0.0
        };
}

export {
  initial_lat_lng ,
}
/* No side effect */
